import Modal from 'developer_components/newModal';
import Select from 'components/select';
import {createElement, isMobile} from 'methods/utils';
import {ajaxGetData} from 'methods/ajaxData';
import IMask from 'imask';

function Feedback() {
    this._loadModalPromise = {};

    this.init();
}

Feedback.prototype.init = function () {
    document.querySelectorAll('.js-feedbackOpen').forEach(($button) => {
        $button.addEventListener('click', () => {
            this._openModal({
                feedback: $button.dataset.feedback,
                hotel_id: $button.dataset.hotel_id,
            });
        });
    });
}

Feedback.prototype._openModal = function (data) {
    this._loadModal(data).then((modal) => {
        modal.open();
    });
}

Feedback.prototype._loadModal = function (data) {
    const key = JSON.stringify(data);

    if (this._loadModalPromise[key]) {
        return this._loadModalPromise[key];
    }

    const formData = new FormData();
    formData.append('feedback', data.feedback);
    formData.append('hotel_id', data.hotel_id);

    return this._loadModalPromise[key] = fetch('/feedback/ajax_get_form/', {
        method: 'POST',
        headers: {
            'X-Requested-With': 'XMLHttpRequest',
        },
        body: formData,
    })
    .then(response => response.json())
    .then(r => {
        if (r.status != 'ok') {
            throw r;
        }

        const modal = new Modal(createElement(r.content));

        this._initPhoneCountrySelect(modal);
        this._initReasonsInputs(modal);
        this._submitFormHandler(modal);

        if (isMobile()) {
            this._initMobileNavigation(modal);
        }

        return modal;
    });
}

Feedback.prototype._initPhoneCountrySelect = function (modal) {
    const $phone = modal.$element.querySelector('[name="phone"]');

    let imask;

    const onChange = () => {
        const $option = select.getSelectedItem();
        const mask = $option.dataset.format
            .replace(/\\d\{(\d+)\}/g, function (match, count) {
                return '0'.repeat(count);
            });

        if (imask) {
            imask.destroy();
            $phone.value = '';
        }

        if (!$phone.value) {
            $phone.value = mask.replace(/^(\+\d+)(.*)$/g, '$1');
        }

        imask = new IMask($phone, {mask});
    }

    ajaxGetData().then(r => {
        if (r.status == 'ok' && r.data.tourist_auth) {
            $phone.value = r.data.tourist_auth.phone;
        }
    });

    const select = new Select(
        modal.$element.querySelector('.Select[data-name="country"]'),
        {
            on: {
                change: onChange,
                ready: onChange,
            }
        }
    );
}

Feedback.prototype._initReasonsInputs = function (modal) {
    const $button = isMobile()
        ? modal.$element.querySelector('.js-feedbackNext')
        : modal.$element.querySelector('.js-feedbackSend');

    modal.$element.querySelectorAll('input[type="radio"][name="field_id"]')
        .forEach(($input) => {
            $input.addEventListener('change', () => {
                $button.disabled = false;
            });
        });
}

Feedback.prototype._initMobileNavigation = function (modal) {
    const $feedback = modal.$element.querySelector('.js-feedback');
    const $nextButton = $feedback.querySelector('.js-feedbackNext');
    const $backButton = $feedback.querySelector('.js-feedbackBack');

    $nextButton.addEventListener('click', () => {
        $feedback.classList.add('is-comment-step');
    });

    $backButton.addEventListener('click', () => {
        $feedback.classList.remove('is-comment-step');
    });
}

Feedback.prototype._submitFormHandler = function (modal) {
    const $form = modal.$element.querySelector('.js-feedbackForm');

    $form.addEventListener('submit', (event) => {
        event.stopPropagation();
        event.preventDefault();

        const formData = new FormData($form);

        fetch($form.action, {
            method: $form.method,
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
            },
            body: formData,
        })
            .then(r => r.json())
            .then(response => {

                if (response.status == 'error') {
                    const $error_fields = response.errors.map((error) => {
                        return $form.querySelector(`[data-name="${error.type}"]`);
                    });

                    $error_fields.forEach(($field) => {
                        $field.classList.add('Input--error');
                    });
                }

                if (response.status == 'ok') {
                    const $title = modal.$element.querySelector('.js-feedbackTitle');
                    const $body = modal.$element.querySelector('.js-feedbackBody');

                    $title.innerHTML = 'Мы получили ваше сообщение';
                    $body.innerHTML = (
                        `<div class="Feedback__container">
                            <div class="Feedback__message">
                                Спасибо, что уделили время. Ваше сообщение, помогают ПриветТур оставаться надежным и безопасным.
                            </div>
                            <div class="Feedback__footer">
                                <button class="Feedback__button is-active js-close" type="button">
                                    Готово
                                </button>
                            </div>
                        </div>`
                    );

                    $body.querySelector('.js-close').addEventListener('click', () => {
                        modal.close();
                    });
                }
            });
    });
}

export default Feedback;
